import { useCallback, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useApplicationKeyValuePairs } from "../../../../../hooks/useApplicationKeyValuePairs"
import { useDeleteConfirm } from "../../../../../hooks/useDeleteConfirm"
import { ApplicationKeyValuePairGet } from "../../../../models/ApplicationKeyValuePair"
import { deleteEntity } from "../../../../utils/deleteEntity"
import { DiMaAddButton } from "../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"

export function ApplicationKeyValuePairs() {
  const { applicationId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const { applicationKeyValuePairs, isLoadingApplicationKeyValuePairs } =
    useApplicationKeyValuePairs(applicationId)

  const applicationKeyValuePairsColumns = [
    {
      field: "key",
      headerName: "Key",
      isLink: true,
      linkBasePath: `/applications/${applicationId}/keyValuePairs`,
    },
    { field: "value", headerName: "Value" },
  ]

  const sorted = [...applicationKeyValuePairs].sort(
    (a: ApplicationKeyValuePairGet, b: ApplicationKeyValuePairGet) =>
      (a.key ?? "").localeCompare(b.key ?? "")
  )

  const applicationKeyValuePairsRows = sorted.map(
    (applicationKeyValuePair: ApplicationKeyValuePairGet) => ({
      id: applicationKeyValuePair.id,
      key: applicationKeyValuePair.key,
      value: applicationKeyValuePair.value,
    })
  )

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/applications/${applicationId}/keyValuePairs/create`}
        feature="AM"
      />
    ),
    [applicationId]
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(`/applications/${applicationId}/keyValuePairs/${row.id}`)
        )
      }
    },
    [applicationId, requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={applicationKeyValuePairsRows}
        cols={applicationKeyValuePairsColumns}
        isLoading={isLoadingApplicationKeyValuePairs}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
